import { createBrowserHistory, To } from 'history'

// supervisor_web is served under a base path (see vite.config `base` and the
// router basename in main.tsx): '/supervisor' on the dev/clinic host, '/' on
// imo-motion.com. `history` v5 has no basename option, so redux sagas that call
// history.replace('/login') etc. directly — bypassing react-router's basename
// handling — would jump to the domain root. Prefix those absolute paths with the
// base here. Paths coming from react-router (useNavigate/Link) already include
// the base, so they are left untouched.
//
// At the root base BASE_URL is '/', which strips to '' — then every absolute
// path already satisfies hasBase() and withBase becomes a no-op, which is
// exactly right: there is no prefix to add.
const BASE = import.meta.env.BASE_URL.replace(/\/$/, '')

const customHistory = createBrowserHistory()

const hasBase = (pathname: string) =>
  pathname === BASE || pathname.startsWith(`${BASE}/`)

const withBase = (to: To): To => {
  if (typeof to === 'string') {
    return hasBase(to) ? to : `${BASE}${to}`
  }
  if (to.pathname && !hasBase(to.pathname)) {
    return { ...to, pathname: `${BASE}${to.pathname}` }
  }
  return to
}

const originalPush = customHistory.push.bind(customHistory)
const originalReplace = customHistory.replace.bind(customHistory)

customHistory.push = (to: To, state?: unknown) => originalPush(withBase(to), state)
customHistory.replace = (to: To, state?: unknown) =>
  originalReplace(withBase(to), state)

export default customHistory
